import { render, staticRenderFns } from "./navpath.vue?vue&type=template&id=2ba6d8d8&scoped=true&"
import script from "./navpath.vue?vue&type=script&lang=js&"
export * from "./navpath.vue?vue&type=script&lang=js&"
import style0 from "./navpath.vue?vue&type=style&index=0&id=2ba6d8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6d8d8",
  null
  
)

export default component.exports